module.exports = __webpack_public_path__ + "img/hyx.bd852fe5.png";